import cookie from 'react-cookie';
import { combineReducers } from 'redux';
import { CURRENCY_UPDATED } from './actions';

function currency(state = cookie.load('currency') || 'eur', action) {
    switch (action.type) {
        case CURRENCY_UPDATED:
            return action.payload;
        default:
            return state;
    }
}

export const reducer = combineReducers({ currency });



// WEBPACK FOOTER //
// ./src/currency/reducers.js